export enum AlreadyBookedModalDatahooks {
  Modal = 'already-booked-modal',
}
